import React, { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../App';

const AuthCallback = () => {
  const navigate = useNavigate();
  const { login } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    // Prevent double processing in StrictMode
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const processAuth = async () => {
      try {
        // Extract session_id from URL hash
        const hash = window.location.hash;
        const params = new URLSearchParams(hash.replace('#', ''));
        const sessionId = params.get('session_id');

        if (!sessionId) {
          console.error('No session_id found');
          navigate('/login');
          return;
        }

        // Exchange session_id for user data
        await login(sessionId);
        
        // Clear hash and redirect to dashboard
        window.history.replaceState(null, '', window.location.pathname);
        navigate('/', { replace: true });
      } catch (error) {
        console.error('Auth callback error:', error);
        navigate('/login');
      }
    };

    processAuth();
  }, [login, navigate]);

  return (
    <div className="liquid-background">
      <div className="blob-1 liquid-blob"></div>
      <div className="blob-2 liquid-blob"></div>
      <div className="blob-3 liquid-blob"></div>
      
      <div className="relative z-10 min-h-screen flex items-center justify-center">
        <div className="glass-panel rounded-3xl p-10 text-center">
          <div className="animate-spin w-10 h-10 border-2 border-white/30 border-t-white rounded-full mx-auto mb-4"></div>
          <p className="text-white/70">Connexion en cours...</p>
        </div>
      </div>
    </div>
  );
};

export default AuthCallback;
